import styled from '@emotion/styled';

const ResultCard = styled.div`
    background-color: ${props => props.theme.cardColor};
    border: 1px solid ${({theme}) => theme.borderColor};
    border-radius: 10px;
    padding: 24px 16px;
    
    @media ${({theme}) => theme.mobile} {
        padding: 16px;
    };
`;

export default ResultCard;
